import * as React from 'react';
import { List, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';
import {
  ViewWeek as ViewWeekIcon,
  FileCopy as FileCopyIcon,
  Storage as StorageIcon,
  Create as CreateIcon,
  Gavel as GavelIcon,
  ImportContacts as MenuBookIcon,
  Info as InfoIcon,
} from '@material-ui/icons';

interface Props {
  goUploadPage: () => void;
  goUploadHighlightPage: () => void;
  goUploadSearchPage: () => void;
  goSearchPage: () => void;
  goUpalodRiskJudgePage: () => void;
}

const SideMenuList: React.SFC<Props> = (props) => {
  const {
    goUploadPage,
    goUploadHighlightPage,
    goUploadSearchPage,
    goSearchPage,
    goUpalodRiskJudgePage,
  } = props;
  const dividerStyle = {
    backgroundColor: '#FFFFFF',
    marginTop: '5px',
    marginBottom: '5px',
    borderTop: 'medium solid #a9a9a9',
  };
  return (
    <List>
      <ListItem button onClick={goUploadSearchPage}>
        <ListItemIcon>
          <ViewWeekIcon />
        </ListItemIcon>
        <ListItemText primary="契約文書の比較" />
      </ListItem>
      <ListItem button onClick={goUploadHighlightPage}>
        <ListItemIcon>
          <FileCopyIcon />
        </ListItemIcon>
        <ListItemText primary="新旧改訂チェック" />
      </ListItem>
      <ListItem button onClick={goUploadPage}>
        <ListItemIcon>
          <StorageIcon />
        </ListItemIcon>
        <ListItemText primary="条項別に抽出" />
      </ListItem>
      <ListItem button onClick={goUpalodRiskJudgePage}>
        <ListItemIcon>
          <GavelIcon />
        </ListItemIcon>
        <ListItemText primary="リスクチェック" />
      </ListItem>
      <ListItem button onClick={() => window.open('https://mchcgr.box.com/s/6uubs9x9nm06mt54ycx5yzit5kfdql2k')}  style={dividerStyle}>
        <ListItemIcon>
          <InfoIcon/>
        </ListItemIcon>
        <ListItemText primary={
          <Typography>ガイダンス</Typography>
          } />
      </ListItem>
      <ListItem button onClick={() => window.open('https://mchcgr.box.com/s/wcmoodhzdet5cu913ymvclb0dawbllnp')} >
        <ListItemIcon>
          <MenuBookIcon />
        </ListItemIcon>
        <ListItemText primary={
          <Typography>ユーザーマニュアル</Typography>
          } />
      </ListItem>
      <ListItem button onClick={goSearchPage} style={dividerStyle}>
        <ListItemIcon>
          <CreateIcon/>
        </ListItemIcon>
        <ListItemText primary={
          <Typography>管理者用画面</Typography>
          } />
      </ListItem>
    </List>
  );
};

export default SideMenuList;



// WEBPACK FOOTER //
// ./src/components/RouteList.tsx